var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/more"
  }, /*#__PURE__*/React.createElement("g", {
    id: "more"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.91667 5.83398C2.275 5.83398 1.75 6.35898 1.75 7.00065C1.75 7.64232 2.275 8.16732 2.91667 8.16732C3.55833 8.16732 4.08333 7.64232 4.08333 7.00065C4.08333 6.35898 3.55833 5.83398 2.91667 5.83398Z",
    fill: "#1E2224"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.0827 5.83398C10.441 5.83398 9.91602 6.35898 9.91602 7.00065C9.91602 7.64232 10.441 8.16732 11.0827 8.16732C11.7243 8.16732 12.2493 7.64232 12.2493 7.00065C12.2493 6.35898 11.7243 5.83398 11.0827 5.83398Z",
    fill: "#1E2224"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.00065 5.83398C6.35898 5.83398 5.83398 6.35898 5.83398 7.00065C5.83398 7.64232 6.35898 8.16732 7.00065 8.16732C7.64232 8.16732 8.16732 7.64232 8.16732 7.00065C8.16732 6.35898 7.64232 5.83398 7.00065 5.83398Z",
    fill: "#1E2224"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.6966df8e3f1b1a19010e6b6a5073b498.svg";
export { ForwardRef as ReactComponent };